<template>
    <div class="popup" :class="classObj">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <statusBar></statusBar>
                <div class="header">
                    <div>{{ $t("bankset.BankCardDetails") }}</div>
                </div>
                <div class="main_content">
                    <banksetNigeria v-if="BelongNation === 'Nigeria'" ref="banksetNigeria" @close="close"
                        @succ="getBank"></banksetNigeria>
                    <banksetRussia v-else-if="BelongNation === 'Russia'" ref="banksetRussia" @close="close"
                        @succ="getBank"></banksetRussia>
                    <bankSetMexico v-else-if="BelongNation === 'Mexico'" ref="banksetMexico" @close="close"
                        @succ="getBank" @onShowPopup="onShowPopup"></bankSetMexico>
                    <bankSetBrazil v-else ref="bankSetBrazil" @close="close" @succ="getBank"></bankSetBrazil>
                </div>
            </div>
            <div class="close-icon" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi" ></i>
            </div>
        </van-popup>
        <withdrawPwdPopup ref="withdrawPwdPopup" @WithDrawSucc="WithDrawSucc"></withdrawPwdPopup>
        <banksetPopupDebit ref="banksetPopupDebit" @setBankSucc="$refs.banksetMexico.getBankList()"></banksetPopupDebit>
        <banksetPopupCLABE ref="banksetPopupCLABE" @setBankSucc="$refs.banksetMexico.getBankList()"></banksetPopupCLABE>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import statusBar from '@/components/statusBar'
import banksetNigeria from './banksetNigeria.vue'
import banksetRussia from './banksetRussia.vue'
import bankSetBrazil from './bankSetBrazil.vue'
import bankSetMexico from './bankSetMexico.vue'
import withdrawPwdPopup from './modules/withdrawPwdPopup'
import banksetPopupDebit from './modules/banksetPopupDebit'
import banksetPopupCLABE from './modules/banksetPopupCLABE'
export default {
    name: 'bankSet',
    components: { statusBar, banksetNigeria, banksetRussia, bankSetBrazil, bankSetMexico, withdrawPwdPopup, banksetPopupDebit, banksetPopupCLABE },
    data() {
        return {}
    },
    props: {
        isCanClose: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowBankSetPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowBankSetPopup', false)
        },
        open() {
            this.$nextTick(() => {
                if (this.BelongNation === 'Pakistan') {
                    // uni.navigateTo({
                    //     url: '/pages/withdraw/banksetPakistan'
                    // })
                } else if (this.BelongNation === 'Nigeria') {
                    this.$refs.banksetNigeria.open()
                } else if (this.BelongNation === 'Russia') {
                    this.$refs.banksetRussia.open()
                } else if (this.BelongNation === 'Mexico') {
                    this.$refs.banksetMexico.open()
                } else {
                    this.$refs.bankSetBrazil.open()
                }
            })
        },
        getBank() {
            this.$emit('getBank')
        },
        WithDrawSucc() {
            if (this.BelongNation === 'Mexico') {
                this.$refs.banksetMexico.WithDrawSucc()
            }
        },
        onShowPopup(e) {
            this.$refs[e].open()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;

        .content {
            box-sizing: border-box;
            border: .01rem solid transparent;
            background-image:
                linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
                linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
            background-origin: border-box;
            background-clip: content-box, border-box;
            box-shadow: var(--theme-popup-box-shadow);
            border-radius: .2rem;
            width: 94%;
            max-width: 500px;
            max-height: 80vh;
            // height: 700px;
            box-sizing: border-box;
            position: relative;
            overflow: auto;
            display: flex;
            flex-direction: column;
            overflow: auto;

            .header {
                display: flex;
                height: 1rem;
                padding-left: .46rem;
                font-family: Tahoma, Tahoma;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: .1rem;
                // background: $bg-component-ocean-deep-color;

                &>div:first-child {
                    font-size: .32rem;
                    font-weight: bold;
                    color: var(--theme-bright-text);
                }

                .close {
                    color: $font-component-muted-color;
                    font-size: .36rem;
                    font-weight: bold;
                    height: 1rem;
                    width: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }

            .main_content {
                overflow: auto;
            }
        }
        .close-icon {
            background: var(--theme-popup-close-bg);
            border: .01rem solid var(--theme-popup-close-border);
            width: .68rem;
            height: .68rem;
            border-radius: .12rem;
            align-items: center;
            justify-content: center;
            display: flex;
            cursor: pointer;
            margin-top: .28rem;

            i {
                 color: var(--theme-bright-text);font-size: .32rem;
                vertical-align: middle;
                line-height: 1;
            }
        }
    }

    // &.mobile {
    //     // width: 100% !important;
    //     // height: 100% !important;

    //     .van-popup {
    //         &.van-popup--center {
    //             top: 0;
    //             left: 0;
    //             transform: translate3d(0, 0, 0);
    //             width: 100% !important;
    //             height: 100% !important;
    //         }
    //     }

    //     .content {
    //         width: 100% !important;
    //         height: 100% !important;
    //         padding-left: 0 !important;
    //         max-height: 100% !important;
    //     }
    // }
}
</style>
